var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 100 100"}},_vm._l((7),function(n){return _c('circle',{key:n,attrs:{"cx":50,"cy":50,"r":n * 7,"fill":_vm.fillColor(n)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }